import axios from "axios";
import { config } from "../../Config";

export const baseURL = config.url.apiEndPoint;

const api = axios.create({
  baseURL: process.env.PLATAFORMA_BACKEND_URL || baseURL,
});

export async function listDistribuidoras() {
  try {
    const data = {
      PageNumber: 1,
      PageSize: 999999,
      filter: { idSimuladorTipo: config.simulacao.idSimuladorTipo },
    };

    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/simulacao/parametro/list`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao listar distribuidoras:", error);
    throw error;
  }
}

export async function simularEconomia(data) {
  try {
    data = {
      ...data,
      ...config.simulacao,
    };

    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/v2/simulacao/landingpage/lead/tim/obter`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao simular economia:", error);
    throw error;
  }
}

export async function newSimularEconomia(data) {
  try {
    data = {
      ...data,
      ...config.simulacao,
    };

    const response = await axios.post(
      `${baseURL}/v3/simulacao/landingpage/lead/tim/obter`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data: response.data,
      statusCode: response.status,
    };
  } catch (error) {
    console.error("Erro ao simular economia:", error);
    throw error;
  }
}

export async function newSimuladorObterFatura(data) {
  try {
    data = {
      ...data,
      ...config.simulacao,
    };

    const response = await axios.post(
      `${baseURL}/v3/simulacao/landingpage/lead/tim/obter`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data: response.data,
      statusCode: response.status,
    };
  } catch (error) {
    console.error("Erro ao simular economia:", error);
    throw error;
  }
}

export async function verifyOtp(data) {
  try {
    const response = await axios.post(
      `${process.env.PLATAFORMA_BACKEND_URL || baseURL}/auth/otp/verify`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function requestOtp(data) {
  try {
    const response = await axios.post(
      `${process.env.PLATAFORMA_BACKEND_URL || baseURL}/auth/otp`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function uploadPlanilhaCreditScore(data) {
  try {
    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/score-lead/excel/incluir`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload da planilha de credit score:", error);
    throw error;
  }
}

export async function uploadFaturaS3(urlPresign, file) {
  try {
    const myHeaders = new Headers();
    myHeaders.append("sec-ch-ua-platform", '"Windows"');
    myHeaders.append("Referer", "http://localhost:3000/");
    myHeaders.append(
      "User-Agent",
      "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/139.0.0.0 Safari/537.36"
    );
    myHeaders.append(
      "sec-ch-ua",
      '"Not;A=Brand";v="99", "Google Chrome";v="139", "Chromium";v="139"'
    );
    myHeaders.append("sec-ch-ua-mobile", "?0");
    myHeaders.append(
      "Content-Type",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );

    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(urlPresign, {
      method: "PUT",
      body: formData,
      headers: myHeaders,
    });

    if (!response.ok) {
      console.error(
        `Erro HTTP no upload: ${response.status} - ${response.statusText}`
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
  } catch (error) {
    console.error("Erro ao fazer upload da planilha para S3:", error);

    // Se o erro for relacionado a CSP, fornecer uma mensagem mais clara
    if (
      error.message.includes("Content Security Policy") ||
      error.name === "TypeError"
    ) {
      console.error(
        "Possível erro de CSP detectado. Verifique a configuração de Content Security Policy."
      );
    }

    throw error;
  }
}

export async function confirmarEnvioFatura(data) {
  try {
    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/v3/simulacao/landingpage/lead/tim/enviarFatura`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export default api;
